<template>
  <com-page>
    <com-card>
      <el-descriptions title="订单信息" :column="4">
        <el-descriptions-item label="订单号">{{ detail.number }}</el-descriptions-item>
        <el-descriptions-item label="套餐卡名称">{{ detail.packageCardName }}</el-descriptions-item>
        <el-descriptions-item label="套餐类型">{{ packageTypes[detail.monthCardPlanBean && detail.monthCardPlanBean.durationType] }}</el-descriptions-item>
        <el-descriptions-item label="套餐名称">{{ detail.packageName }}</el-descriptions-item>
        <el-descriptions-item label="订单金额">{{ detail.money }}</el-descriptions-item>
        <el-descriptions-item label="支付金额">{{ detail.paySum }}</el-descriptions-item>
        <el-descriptions-item label="下单时间">{{ detail.orderTime | timeFormate }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ packageCardOrderStatus[detail.cardOrderStatus] }}</el-descriptions-item>
        <el-descriptions-item label="开通时间">{{ detail.registerTime | timeFormate }}</el-descriptions-item>
        <el-descriptions-item label="剩余时长">{{ detail.surplusTime }}</el-descriptions-item>
        <el-descriptions-item label="已用时长">{{ detail.usedTime }}</el-descriptions-item>
        <el-descriptions-item label="有效期至">{{ detail.overdueTime | timeFormate }}</el-descriptions-item>
        <el-descriptions-item label="套餐卡状态">{{ packageCardStatus[detail.cardStatus] }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ detail.userNumber }}</el-descriptions-item>
        <el-descriptions-item label="用户手机号">{{ detail.phone }}</el-descriptions-item>
        <el-descriptions-item label="订单分成">
          <el-button type="text" style="padding: 2px 7px" @click="openOrderDivvyDialog">查看</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </com-card>

    <order-divvy-dialog ref="orderDivvyDialogRef" type="package-order" />
  </com-page>
</template>

<script>
import { packageOrderDetailApi } from '@/api/package-order'
import { packageTypes, packageCardStatus, packageCardOrderStatus } from '@/json/common'

import OrderDivvyDialog from './components/order-divvy-dialog'

export default {
  components: { OrderDivvyDialog },
  data() {
    return {
      code: '',
      detail: {},
      packageTypes,
      packageCardOrderStatus,
      packageCardStatus
    }
  },
  created() {
    this.code = this.$route.query.code

    this.getDetail()
  },
  methods: {
    getDetail() {
      packageOrderDetailApi({ code: this.code }).then(res => {
        this.detail = res.data
      })
    },

    openOrderDivvyDialog() {
      this.$refs.orderDivvyDialogRef.open(this.detail)
    }
  },
}
</script>

<style lang="scss" scoped></style>
